import { TagInput } from 'components/TagInput/TagInput'
import { CategoryDropdown } from '../CategoryDropDown/CategoryDropDown'
import { BlogMetadataCategoriesState, BlogMetadataCategoriesHandlers } from '../../../hooks/useBlogMetadataCategories'
import { BlogMetadataTagsState } from '../../../hooks/useBlogMetadataTags'
import Styles from '../../../BlogMetadata.module.scss'

interface BlogMetadataCategoriesSectionProps {
  categoriesState: BlogMetadataCategoriesState
  categoriesHandlers: BlogMetadataCategoriesHandlers
  tagsState: BlogMetadataTagsState
  tagsHandlers: {
    handleTagsChange: (tags: string[]) => void
  }
  useCategoryDropdown?: boolean
  availableCategories?: string[]
  allowAddingCategories?: boolean
}

export const BlogMetadataCategoriesSection: React.FC<BlogMetadataCategoriesSectionProps> = ({
  categoriesState,
  categoriesHandlers,
  tagsState,
  tagsHandlers,
  useCategoryDropdown = false,
  availableCategories = [],
  allowAddingCategories = true,
}) => {
  const { selectedCategories } = categoriesState
  const { handleCategoriesChange, handleCategoryDropdownClose } = categoriesHandlers
  const { tags } = tagsState
  const { handleTagsChange } = tagsHandlers

  return (
    <>
      <div className={Styles.tagsContainer}>
        <label className={Styles.textFieldLabel}>Categories</label>
        <div className={useCategoryDropdown ? Styles.categoryDropdown : Styles.blogTagInputContainer}>
          {useCategoryDropdown ? (
            <CategoryDropdown
              availableCategories={availableCategories}
              selectedCategories={selectedCategories}
              onCategoriesChange={handleCategoriesChange}
              onDropdownClose={handleCategoryDropdownClose}
              allowAddingCategories={allowAddingCategories}
            />
          ) : (
            <TagInput
              tags={selectedCategories}
              onChange={handleCategoriesChange}
              placeholder="Add a category"
              useAddPill
              size="md"
              wrapperClassName={Styles.blogTagInputContainer}
            />
          )}
        </div>
      </div>
      <div className={Styles.tagsContainer}>
        <label className={Styles.textFieldLabel}>Tags</label>
        <div className={Styles.blogTagInputContainer}>
          <TagInput
            tags={tags}
            onChange={handleTagsChange}
            placeholder={'Add a tag'}
            useAddPill
            size="md"
            wrapperClassName={Styles.blogTagInputContainer}
          />
        </div>
      </div>
    </>
  )
}
